import { useEffect } from "react";
import {
  dadosEstruturados, IMAGEM_SOCIAL, paginaSeo, type CaminhoPublico, type SeoPagina,
} from "../seo.js";

function definirMeta(seletor: string, atributo: "name" | "property", chave: string,
  conteudo: string) {
  let elemento = document.head.querySelector<HTMLMetaElement>(seletor);
  if (!elemento) {
    elemento = document.createElement("meta");
    elemento.setAttribute(atributo, chave);
    document.head.appendChild(elemento);
  }
  elemento.content = conteudo;
}

/** Mantém o head correto também quando a navegação acontece sem recarregar. */
export function MetadadosPagina({ caminho }: { caminho: CaminhoPublico }) {
  useEffect(() => {
    const seo: SeoPagina = paginaSeo(caminho);
    document.title = seo.titulo;
    definirMeta('meta[name="description"]', "name", "description", seo.descricao);
    definirMeta('meta[name="robots"]', "name", "robots", seo.robots);
    definirMeta('meta[property="og:title"]', "property", "og:title", seo.titulo);
    definirMeta('meta[property="og:description"]', "property", "og:description",
      seo.descricaoSocial ?? seo.descricao);
    definirMeta('meta[property="og:type"]', "property", "og:type",
      seo.tipoOpenGraph ?? "website");
    definirMeta('meta[property="og:url"]', "property", "og:url", seo.canonical);
    const imagemSocial = seo.imagemSocial ?? IMAGEM_SOCIAL;
    definirMeta('meta[property="og:image"]', "property", "og:image", imagemSocial);
    definirMeta('meta[property="og:image:width"]', "property", "og:image:width",
      String(seo.imagemSocialLargura ?? 512));
    definirMeta('meta[property="og:image:height"]', "property", "og:image:height",
      String(seo.imagemSocialAltura ?? 512));
    definirMeta('meta[property="og:image:alt"]', "property", "og:image:alt",
      seo.imagemSocialAlt ?? "Marca Alugando.com");
    definirMeta('meta[name="twitter:title"]', "name", "twitter:title", seo.titulo);
    definirMeta('meta[name="twitter:description"]', "name", "twitter:description",
      seo.descricaoSocial ?? seo.descricao);
    definirMeta('meta[name="twitter:image"]', "name", "twitter:image", imagemSocial);

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = seo.canonical;

    let ld = document.head.querySelector<HTMLScriptElement>("#dados-estruturados");
    if (!ld) {
      ld = document.createElement("script");
      ld.id = "dados-estruturados";
      ld.type = "application/ld+json";
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify(dadosEstruturados(caminho));
  }, [caminho]);
  return null;
}

export function MetadadosPrivados() {
  useEffect(() => {
    document.title = "Alugando.com";
    definirMeta('meta[name="robots"]', "name", "robots", "noindex,nofollow,noarchive");
    document.head.querySelector('link[rel="canonical"]')?.remove();
    document.head.querySelector("#dados-estruturados")?.remove();
  }, []);
  return null;
}
